import { store } from 'store';
import { openAlert } from 'modules/alertHandler';
import { IAlertHandlerState } from 'modules/alertHandler/interfaces';

interface ShowErrorResponseParams {
  alertProps: IAlertHandlerState;
  errorLog: {
    errorMsg: string;
    error: string;
  };
}

export const showErrorResponse = ({
  alertProps,
  errorLog,
}: ShowErrorResponseParams): void => {
  store.dispatch(openAlert(alertProps));
  console.error(errorLog.errorMsg, errorLog.error);
};
